import { styled } from 'baseui'
import { FlexColumn } from '@/shared/theme/styled-components'

export const Stack = styled(FlexColumn, {
  gap: '0.75rem',
})

export const FiltersRow = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '0.75rem',
})

export const SearchInputWrap = styled('div', {
  minWidth: '14rem',
  flex: '1 1 14rem',
})

export const DateInputWrap = styled('div', {
  width: '9.5rem',
})

export const SelectWrap = styled('div', {
  width: '10rem',
})

export const NotificationsWrapper = styled(FlexColumn, {
  marginTop: '0.75rem',
  gap: '0.5rem',
})

export const TableWrap = styled('div', {
  position: 'relative',
  overflowX: 'auto',
  marginTop: '-0.45rem',
})

export const Table = styled('table', {
  width: '100%',
  borderCollapse: 'separate',
  borderSpacing: 0,
})

export const TheadRow = styled('tr', {
  textAlign: 'left',
})

export const Th = styled('th', ({ $theme }) => ({
  paddingTop: '0.35rem',
  paddingBottom: '0.35rem',
  paddingLeft: '0.75rem',
  paddingRight: '0.75rem',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: $theme.colors.borderLight,
  fontSize: '0.9125rem',
  color: $theme.colors.textMuted,
  fontWeight: 600,
  whiteSpace: 'nowrap',
}))

export const Td = styled('td', ({ $theme }) => ({
  paddingTop: '0.35rem',
  paddingBottom: '0.35rem',
  paddingLeft: '0.65rem',
  paddingRight: '0.65rem',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: $theme.colors.bgAccordion,
  fontSize: '0.875rem',
  verticalAlign: 'middle',
}))

export const FooterRow = styled('div', {
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  alignItems: 'center',
  marginTop: '0.75rem',
})

export const FooterActions = styled('div', {
  gridColumn: 2,
  display: 'flex',
  gap: '0.5rem',
  justifyContent: 'center',
})

export const FeedbackBadge = styled('span', ({ $upvote }) => ({
  display: 'inline-block',
  width: '1.125rem',
  height: '1.125rem',
  borderRadius: '50%',
  backgroundColor: $upvote ? '#36b37e' : '#de350b',
  border: '2px solid #e2e2e2',
  verticalAlign: 'middle',
}))
